import { GetUserApi } from "../api/request/users.js";
import { getCorporateAccount } from "../api/request/corporate.js";
import { getIndividualAccount } from "../api/request/individualOnboarding.js";

export const ACCOUNT_TYPE = {
  INDIVIDUAL: 1,
  CORPORATE: 2,
};

const readAccountTypeValue = (source) => {
  if (source == null || typeof source !== "object") return source;
  return (
    source.accountType ??
    source.AccountType ??
    source.clientType ??
    source.userAccountType ??
    source.account_type ??
    null
  );
};

export const resolveAccountType = (source) => {
  const raw = typeof source === "object" ? readAccountTypeValue(source) : source;
  if (raw === null || raw === undefined || raw === "") return null;

  const numeric = Number(raw);
  if (numeric === ACCOUNT_TYPE.INDIVIDUAL || numeric === ACCOUNT_TYPE.CORPORATE) {
    return numeric;
  }

  const label = String(raw).trim().toLowerCase();
  if (label === "individual" || label === "user" || label === "person") {
    return ACCOUNT_TYPE.INDIVIDUAL;
  }
  if (label === "corporate" || label === "company" || label === "business") {
    return ACCOUNT_TYPE.CORPORATE;
  }

  return null;
};

export const getOnboardingPath = (accountTypeOrUser) => {
  const type = resolveAccountType(accountTypeOrUser);
  if (type === ACCOUNT_TYPE.CORPORATE) return "/corporate";
  if (type === ACCOUNT_TYPE.INDIVIDUAL) return "/individual-onboarding";
  return null;
};

export const getPostLoginPath = (accountTypeOrUser) => {
  return getOnboardingPath(accountTypeOrUser) || "/dashboard";
};

export const getUserId = (user) =>
  user?.id || user?._id || user?.userId || user?.userID || null;

export const withResolvedAccountType = (user) => {
  if (!user) return user;
  const accountType = resolveAccountType(user);
  if (accountType == null) return user;
  return { ...user, accountType };
};

export const enrichUserWithAccountType = async (user) => {
  if (!user) return user;

  const existing = resolveAccountType(user);
  if (existing) return { ...user, accountType: existing };

  const userId = getUserId(user);
  if (userId) {
    try {
      const { data } = await GetUserApi(userId);
      if (data?.success && data?.data) {
        const fromProfile = resolveAccountType(data.data);
        if (fromProfile) {
          return { ...user, ...data.data, accountType: fromProfile };
        }
        user = { ...user, ...data.data };
      }
    } catch (error) { }
  }

  try {
    const { data } = await getIndividualAccount();
    if (data?.success) {
      return { ...user, accountType: ACCOUNT_TYPE.INDIVIDUAL };
    }
  } catch (error) { }

  try {
    const { data } = await getCorporateAccount();
    if (data?.success) {
      return { ...user, accountType: ACCOUNT_TYPE.CORPORATE };
    }
  } catch (error) { }

  return user;
};

export const getCountryDialCode = (item) => {
  const raw = String(item?.dialCode || item?.countryCode1 || "").trim();
  if (!raw) return "";
  const digits = raw.replace(/[^0-9+]/g, "");
  return digits.startsWith("+") ? digits : `+${digits}`;
};

export const canSwitchIbDashboard = (user) => {
  if (!user) return false;
  if (user.ibRequestStatus === "Approved") return true;

  const role = String(user.roleName || "").trim().toLowerCase();
  if (role === "ibuser" || role === "ib") return true;

  const isIb = user.isIBUser;
  if (isIb === true || isIb === 1) return true;
  if (typeof isIb === "string") {
    const normalized = isIb.trim().toLowerCase();
    if (normalized === "true" || normalized === "yes" || normalized === "1") {
      return true;
    }
  }

  return false;
};
